import { Pencil, Trash2, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { formatDate } from "@/lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

const DeleteButton = ({ post, onDelete }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button className="p-2 text-[#5C564E] hover:text-red-700 transition-colors" aria-label="Delete" data-testid={`post-delete-button-${post.slug}`}>
        <Trash2 className="h-4 w-4" strokeWidth={1.5} />
      </button>
    </AlertDialogTrigger>
    <AlertDialogContent className="bg-[#F6F2E8]">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display">Delete “{post.title}”?</AlertDialogTitle>
        <AlertDialogDescription>This permanently removes the article from the site.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="post-delete-cancel-button">Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={() => onDelete(post)} className="bg-[#16302B]" data-testid="post-delete-confirm-button">Delete</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const PostList = ({ posts, onEdit, onDelete }) => {
  if (!posts.length) return <p className="mt-10 font-display italic text-xl text-[#5C564E]" data-testid="admin-posts-empty">No articles yet.</p>;
  return (
    <ul className="mt-10 border-t border-[#221F1B]" data-testid="admin-post-list">
      {posts.map((p) => (
        <li key={p.id} className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 py-5 border-b border-[#D8CFBC]" data-testid={`admin-post-row-${p.slug}`}>
          <div>
            <p className="font-display text-xl text-[#221F1B]">{p.title}</p>
            <p className="text-[13px] text-[#5C564E] mt-1">
              <span className={p.published ? "text-[#16302B]" : "text-[#B8874A]"}>{p.published ? "Published" : "Draft"}</span> · {p.category} · {formatDate(p.created_at)}
            </p>
          </div>
          <div className="flex items-center gap-1">
            {p.published && (
              <Link to={`/blog/${p.slug}`} target="_blank" className="p-2 text-[#5C564E] hover:text-[#16302B]" aria-label="View" data-testid={`post-view-link-${p.slug}`}>
                <ExternalLink className="h-4 w-4" strokeWidth={1.5} />
              </Link>
            )}
            <button onClick={() => onEdit(p)} className="p-2 text-[#5C564E] hover:text-[#16302B]" aria-label="Edit" data-testid={`post-edit-button-${p.slug}`}>
              <Pencil className="h-4 w-4" strokeWidth={1.5} />
            </button>
            <DeleteButton post={p} onDelete={onDelete} />
          </div>
        </li>
      ))}
    </ul>
  );
};
